import { Form, Input, Modal, Select, Spin, Icon } from "antd";
import React, { Component } from "react";
import axios from "axios";
import { Constant } from "../../config/index";

const { Option } = Select;

function debounce(func, delay = 500) {
  let timer;

  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

class SendersDefaultForm extends Component {
  state = {
    searchLoading: false,
    searchedPoolList: [],
  };

  componentDidUpdate = async (prevProps) => {
    const { data: pd } = prevProps;
    const { data: d, form } = this.props;

    if (d && (d.id !== pd.id || d.senders_pool_id !== pd.senders_pool_id))
      form.setFieldsValue(d);
  };

  handleCancelModal = () => {
    const { onCancel, form } = this.props;

    this.setState({
      searchLoading: false,
      searchedPoolList: [],
    });

    form.resetFields();
    onCancel();
  };

  handleOnSearch = async (targetSender) => {
    this.setState({
      searchLoading: true,
    });

    if (String(targetSender).trim().length === 0) {
      this.setState({
        searchLoading: false,
      });
      return;
    }

    this.setState({
      searchedPoolList: await this.getSenderList(targetSender),
      searchLoading: false,
    });
  };

  getSenderList = async (sender) => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_POOL_API}/find`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "GET",
      params: {
        search: sender,
      },
      url,
    };

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  };

  render() {
    const {
      visible,
      onCreate,
      form,
      flagCreateOrUpdateForm,
      loading,
      data,
      sendersPoolList,
      getGatewayTag,
      getCountryAbbrTag,
    } = this.props;
    const { getFieldDecorator } = form;

    let okText = flagCreateOrUpdateForm ? "เพิ่ม" : "แก้ไข";
    let title =
      okText + " Senders " + (data.id ? ` - SENDERS${data.id || 0}` : "");

    const renderSenderList = () => {
      let targetSenderList = [];
      if (this.state.searchedPoolList.length > 0) {
        targetSenderList = this.state.searchedPoolList;
      } else {
        targetSenderList = sendersPoolList;
      }

      return targetSenderList.map((item, i) => (
        <Option key={i} value={item.id}>
          {getCountryAbbrTag(item.country_abbr || "")}
          {getGatewayTag(item.gateway_detail.key_name || "")}
          {`${item.sender}`}
        </Option>
      ));
    };

    return (
      <Modal
        visible={visible}
        title={title}
        okText={okText}
        cancelText="ยกเลิก"
        onCancel={this.handleCancelModal}
        onOk={onCreate}
        maskClosable={false}
        style={{ top: 20 }}
        loa
      >
        <Spin spinning={loading} tip="กำลังบันทึกข้อมูล...">
          <Form>
            {getFieldDecorator("id")(<Input type="hidden" />)}
            <Form.Item label="Sender">
              {getFieldDecorator("senders_pool_id", {
                rules: [{ required: true, message: "กรุณาเลือก Sender" }],
              })(
                <Select
                  showSearch
                  placeholder="กรุณาเลือก Sender"
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    if (typeof option.props.children[2] === "undefined")
                      return false;

                    const val = (option.props.children[2] || "").toLowerCase();
                    const ipt = (input || "").toLowerCase();

                    return val.indexOf(ipt) >= 0;
                  }}
                  onSearch={debounce(
                    (search) => this.handleOnSearch(search),
                    500
                  )}
                  loading={this.state.searchLoading}
                  notFoundContent={
                    this.state.searchLoading ? (
                      <div>
                        <Spin size="small" /> Loading the sender list...
                      </div>
                    ) : (
                      <div>
                        <Icon type="question" /> Please ensure that the sender
                        was exist in pool first.
                      </div>
                    )
                  }
                >
                  {renderSenderList()}
                </Select>
              )}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default Form.create({ name: "senders_default_form" })(
  SendersDefaultForm
);



// WEBPACK FOOTER //
// ./src/containers/Senders/default-form.js